import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback } from 'react';
import { BroadcastStateService } from '../../services/broadcaststate/BroadcastStateService';
import { EnvironmentService } from '../../services/environment/EnvironmentService';
import { PluginApiService } from '../../services/pluginapi/PluginApiService';
import { PluginListService } from '../../services/pluginlist/PluginListService';
import { formPluginUrl } from '../../utils/routes';
export function PluginPanelContainer({ slotId }) {
    const { myRole } = BroadcastStateService.getOutput().useRequiredActiveBroadcast();
    const pluginOutputSlots = PluginListService.getOutput().useSlots();
    const currentSlotPlugins = pluginOutputSlots[slotId];
    return (_jsx(_Fragment, { children: Object.entries(currentSlotPlugins).map(([keyWithinSlot, plugin]) => (_jsx(PluginRenderer, { slotId: slotId, keyWithinSlot: keyWithinSlot, plugin: plugin, myRole: myRole }, keyWithinSlot))) }));
}
function PluginRenderer({ myRole, slotId, keyWithinSlot, plugin, }) {
    const pluginApiService = PluginApiService.getNotificationInterface();
    const isMobile = EnvironmentService.getOutput().useIsMobile();
    const setRef = useCallback((iframe) => {
        if (iframe !== null) {
            pluginApiService.notifyIframeMounted(slotId, keyWithinSlot, plugin, iframe);
        }
    }, [pluginApiService, slotId, keyWithinSlot, plugin]);
    if (plugin.loadOnlyAtRole && plugin.loadOnlyAtRole !== myRole) {
        return null;
    }
    if (plugin.loadOnlyOnDeviceType) {
        const currentDeviceType = isMobile ? 'mobile' : 'desktop';
        if (plugin.loadOnlyOnDeviceType !== currentDeviceType) {
            return null;
        }
    }
    return (_jsx("iframe", { title: `${plugin.id} ${keyWithinSlot}`, src: formPluginUrl(plugin.pluginId, plugin.urlPath), ref: setRef }));
}
